import { getFieldsFromPropertyId } from 'models/Cropwise';
import { useState, useEffect } from 'react';

export const useFields = (propertyId: string) => {
  const [fields, setFields] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchFields = async () => {
      if (!propertyId) return;

      try {
        setLoading(true);
        setError(null);
        let fetchedFields = await getFieldsFromPropertyId(propertyId);

        if (!fetchedFields) fetchedFields = [];

        fetchedFields.sort(({ name: name1 }: any, { name: name2 }: any) =>
          name1 > name2 ? 1 : -1,
        );

        setFields(fetchedFields);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch fields'));
        console.error('Error fetching fields:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFields();
  }, [propertyId]);

  return { fields, loading, error };
};
